import { adminApi } from '~/api'
import { useMutation } from '@tanstack/react-query'

export const useEditUserMutation = () => {
  return useMutation((values) => {
    return adminApi.editUser(values.id, values)
  })
}
